import React, { useState } from "react";
import Button from "../../components/Common/Button";
import FormActions from "../../components/Form/FormActions";
import FormContainer from "../../components/Form/FormContainer";
import FormItems from "../../components/Form/FormItems";
import { IzobrazevanjeTipListType } from "../../types/IzobrazevanjeTip/IzobrazevanjeTipListType";
import Nullable from "../../types/Nullable";
import { PodrocjeFormType } from "../../types/Podrocje/PodrocjeFormType";
import { Link, useNavigate } from "react-router-dom";
import ApiException from "../../types/ApiException";
import TextInput from "../../components/Form/TextInput";
import DropdownInput from "../../components/Form/DropdownInput";
import TextArea from "../../components/Form/TextArea";
import DateRange from "../../components/Form/DateRange";
import CheckboxInput from "../../components/Form/CheckboxInput";
import CheckboxItem from "../../components/Form/CheckboxItem";
import Modal from "../../components/Common/Modal";
import { DokumentVrsta, IzobrazevanjeStatus, IzobrazevanjeVrsta } from "../../utils/Enums";
//import FileUpload from "../../components/Common/FileUpload";
import FileUploadField from "../../components/Form/FileUploadField";
import { EventMessageUtils } from "@azure/msal-browser";
import { IzobrazevanjeFormType } from "../../types/Izobrazevanje/IzobrazevanjeFormType";
import { getPathWithBaseURL } from "../../utils/Common";
import useUploadIzobrazevanjeDokument from "../dokument/DokumentHooks";
import { upload } from "@testing-library/user-event/dist/upload";
import getApiExceptionObjectFromAxiosError from "../../utils/ProcessException";

type IzobrazevanjeJavnoFormArgs = {
    izobrazevanje: IzobrazevanjeFormType;
    izobrazevanjeTipi: IzobrazevanjeTipListType[];
    onSaveDraft: (izobrazevanje: IzobrazevanjeFormType, onSuccessCallback?: (izobrazevanje: IzobrazevanjeFormType) => Promise<void>) => void;
    onSavePublish?: (izobrazevanje: IzobrazevanjeFormType, onSuccessCallback?: (izobrazevanje: IzobrazevanjeFormType) => Promise<void>) => void;
    onDelete?: (izobrazevanje: IzobrazevanjeFormType) => void;
    apiException: ApiException | null;
}

// const IzobrazevanjeJavnoForm = ({ izobrazevanje, izobrazevanjeTipi, submittedDraft, submittedPublish, deleted, apiException }: IzobrazevanjeJavnoFormArgs) => {
const IzobrazevanjeJavnoForm = ({ izobrazevanje, izobrazevanjeTipi, onSaveDraft, onSavePublish, onDelete, apiException }: IzobrazevanjeJavnoFormArgs) => {
    // const izobrazevanjeTmp: Pick<IzobrazevanjeFormType, keyof IzobrazevanjeFormType> = { 
    //     ...izobrazevanje 
    // };
    const [izobrazevanjeState, setIzobrazevanjeState] = useState({
        ...izobrazevanje,
        vrsta: IzobrazevanjeVrsta.Javno
    });
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isSlikaChanged, setIsSlikaChanged] = useState(false);
    const [isIzobrazevanjeDokumentChanged, setIsIzobrazevanjeDokumentChanged] = useState(false);
    //const [slikaDokument, setSlikaDokument] = useState<File | null>();
    //const [izobrazevanjeDokument, setIzobrazevanjeDokument] = useState<File | null>();
    const uploadIzobrazevanjeDokument = useUploadIzobrazevanjeDokument();

    const nav = useNavigate();

    const onSuccessCallback = async (izobrazevanje: IzobrazevanjeFormType) => {
        console.log("javno draft saved successfully!");
        console.log("Izobrazevanje:", izobrazevanje);
        await uploadFiles(izobrazevanje.izobrazevanjeId);
    };

    // const updateIzobrazevanjeMutatiedDraft = useUpdateIzobrazevanjeDraft();
    // const updateIzobrazevanjeMutatiedPublish = useUpdateIzobrazevanjePublish();
    // const deleteIzobrazevanje = useDeleteIzobrazevanje();
    // const uploadIzobrazevanjeDokument = useUploadIzobrazevanjeDokument();

    // let apiException: ApiException | null = null;
    // if (updateIzobrazevanjeMutatiedDraft.error)
    //     apiException = getApiExceptionObjectFromAxiosError(updateIzobrazevanjeMutatiedDraft.error);
    // if (updateIzobrazevanjeMutatiedPublish.error)
    //     apiException = getApiExceptionObjectFromAxiosError(updateIzobrazevanjeMutatiedPublish.error);
    // if (uploadIzobrazevanjeDokument.error)
    //     apiException = getApiExceptionObjectFromAxiosError(uploadIzobrazevanjeDokument.error);



    const onSubmitDraft: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        onSaveDraft(izobrazevanjeState, onSuccessCallback);
    }

    const onSubmitPublish: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        if (onSavePublish) {
            e.preventDefault();
            onSavePublish(izobrazevanjeState, onSuccessCallback);
        }
    }

    const showModal: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        e.preventDefault();
        setShowDeleteModal(true);
    }

    const onDeleteConfirm: React.MouseEventHandler<HTMLButtonElement> = async (e) => {
        if (onDelete){
            e.preventDefault();
            onDelete(izobrazevanjeState);
        }
    }
    

    function setSelectIzobrazevanjeTipId(e: React.ChangeEvent<HTMLSelectElement>) {
        const it = izobrazevanjeTipi.filter(it => it.izobrazevanjeTipId === Number(e.target.value))[0];
        setIzobrazevanjeState({
            ...izobrazevanjeState,
            izobrazevanjeTipId: Number(e.target.value)
        })
    }

    const onThumbnailChange = (file: File | null) => {
        setIzobrazevanjeState({
            ...izobrazevanjeState,
            slikaDokument: file == null ? null : izobrazevanjeState.slikaDokument,
            slika: file
        });
        //setSlikaDokument(file);
        setIsSlikaChanged(true);
    };

    const onDocumentChange = (file: File | null) => {
        setIzobrazevanjeState({
            ...izobrazevanjeState,
            izobrazevanjeDokument: file == null ? null : izobrazevanjeState.izobrazevanjeDokument,
            dokument: file
        });
        //setIzobrazevanjeDokument(file);
        setIsIzobrazevanjeDokumentChanged(true);
    };

    async function uploadFiles(izobrazevanjeId: number) {
        console.log("uploadFiles - izobrazevanjeId", izobrazevanjeId);
        if (isSlikaChanged)
            await uploadSlika(izobrazevanjeId);
        if (isIzobrazevanjeDokumentChanged)
            await uploadDokument(izobrazevanjeId);
    }

    async function uploadSlika(izobrazevanjeId: number) {
        console.log("uploadSlika - izobrazevanjeId", izobrazevanjeId);
        await uploadIzobrazevanjeDokument.mutateAsync({
            dokument: izobrazevanjeState.slika ?? null,
            izobrazevanjeId: izobrazevanjeId,
            vrsta: DokumentVrsta.Thumbnail
        });
    }

    async function uploadDokument(izobrazevanjeId: number) {
        console.log("uploadDokument - izobrazevanjeId", izobrazevanjeId);
        await uploadIzobrazevanjeDokument.mutateAsync({
            dokument: izobrazevanjeState.dokument ?? null,
            izobrazevanjeId: izobrazevanjeId,
            vrsta: DokumentVrsta.IzobrazevanjeDokument
        })
    }

    return (
        <FormContainer>
            <Modal
                visible={showDeleteModal}
                message="Ali ste prepričani da želite izbrisati to izobraževanje?"
                actionMessage="izbriši"
                actionIcon="delete"
                onCancel={() => setShowDeleteModal(false)}
                onConfirm={onDeleteConfirm}
            />
            <FormActions>
                <Button startIcon="arrow_back_ios" onClick={() => nav('/izobrazevanje/javno-list')}>nazaj na seznam</Button>
                <Button className="right" onClick={onSubmitPublish} startIcon="done" tertiary>objavi</Button>
            </FormActions>
            <FormItems labelsWidth="27%">
                <TextInput
                    value={izobrazevanjeState.naziv}
                    width="350px"
                    placeholder="Naziv"
                    label="Naziv objave"
                    required={true}
                    err={apiException}
                    errField="Naziv"
                    onChange={(e) => setIzobrazevanjeState({ ...izobrazevanjeState, naziv: e.target.value })}
                />
                 <FileUploadField
                    label="Slika"
                    required
                    /* show “remove” when either a new file or an existing DB file is present */
                    value={izobrazevanjeState.slika ?? (izobrazevanjeState.slikaDokument ? new File([], "") : null)}

                    chooseButtonText={
                        izobrazevanjeState.slika || izobrazevanjeState.slikaDokument
                        ? "Zamenjaj sliko"
                        : "Izberi sliko"
                    }
                    removeButtonText="Odstrani sliko"
                    acceptedFileTypes="image/*"
                    onFileChange={onThumbnailChange}
                    startIcon="upload"
                    tertiary
                    className="izobrazevanjeUploadBtn"
                    removeButtonClassName="izobrazevanjeRemoveBtn"
                    err={apiException}
                    errField="SlikaDokument"
                    />
                {((izobrazevanjeState.slika || izobrazevanjeState.slikaDokument) 
                    && <img src={izobrazevanjeState.slika ? 
                    URL.createObjectURL(izobrazevanjeState.slika) 
                        : izobrazevanjeState.slikaDokument ?
                             getPathWithBaseURL(izobrazevanjeState.slikaDokument.webLink) 
                            : ""} alt="thumbnail" height="150px" className="izobrazevanjeFilePreview"/>
                )} 
                <TextArea
                    width="350px"
                    height="100px"
                    label="Opis"
                    placeholder="Opis"
                    value={izobrazevanjeState.opis ? izobrazevanjeState.opis : ""}
                    onChange={(e) => setIzobrazevanjeState({ ...izobrazevanjeState, opis: e.target.value })}
                    required={false}
                />
                <DropdownInput
                    label="Kategorija"
                    value={izobrazevanjeState.izobrazevanjeTipId}
                    onChange={(e) => setSelectIzobrazevanjeTipId(e)}
                    required={true}
                >
                    {izobrazevanjeTipi && izobrazevanjeTipi.map((it) => (
                        <option key={it.izobrazevanjeTipId} value={it.izobrazevanjeTipId}>{it.naziv}</option>
                    ))}
                </DropdownInput>
                <FileUploadField
                    label="Datoteka (pdf ali video)"
                    required
                    /* show “remove” when either a new file or an existing DB file is present */
                    value={
                        izobrazevanjeState.dokument ??                       // ← pick the NEW file
                        (izobrazevanjeState.izobrazevanjeDokument            // ← or an existing one from DB
                        ? new File([], "") 
                        : null)
                    }
                    chooseButtonText="Izberi datoteko"
                    removeButtonText="Odstrani datoteko"
                    acceptedFileTypes=".pdf, video/*"
                    //showRemoveButton={(izobrazevanjeState.izobrazevanjeDokument != null)} 
                    onFileChange={onDocumentChange}
                    startIcon=""
                    tertiary
                    className="izobrazevanjeUploadBtn"
                    removeButtonClassName="izobrazevanjeRemoveBtn"
                    err={apiException}
                    errField="IzobrazevanjeDokument"
                    />
                {<span className="izobrazevanjeFilePreview">{izobrazevanjeState.dokument ? izobrazevanjeState.dokument.name : izobrazevanjeState.izobrazevanjeDokument?.fileName}</span>}
            </FormItems>
            <FormActions>
                {izobrazevanjeState.status == IzobrazevanjeStatus.VPripravi &&
                    <Button onClick={showModal} startIcon="delete" tertiary>izbriši</Button>
                }
                <div></div>
                <div className="right">
                    <Button onClick={onSubmitDraft} startIcon="save" primary>shrani</Button>
                    <Link to={`/izobrazevanje/javno-list`}>
                        <Button startIcon="close" cancel>prekliči</Button>
                    </Link>
                </div>
            </FormActions>
        </FormContainer>
    );
}

export default IzobrazevanjeJavnoForm;
